var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 505.173 505.173",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#faebb6"
    },
    d: "M344.6,214.453h119.467c18.773,0,34.133,20.48,34.133,39.253s-14.507,27.307-34.133,29.013 c18.773,0,34.133,15.36,34.133,34.133s-15.36,34.133-34.133,34.133H447c18.773,0,34.133,15.36,34.133,34.133 c0,18.773-15.36,34.133-34.133,34.133h-25.6c13.653,0,25.6,11.947,25.6,25.6c0,13.653-12.8,25.6-25.6,25.6h-128 c-68.267,0-59.733-25.6-119.467-34.133H139.8v-204.8h34.133c17.067,0,42.667-17.067,68.267-42.667 c34.133-34.133,34.133-76.8,34.133-145.067c0-9.387,6.827-17.067,17.067-17.067c34.133,0,51.2,17.067,51.2,51.2V214.453z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAB1BA"
    },
    points: "139.8,436.32 139.8,470.453 3.267,470.453 3.267,214.453 139.8,214.453 139.8,231.52 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#faebb6"
    },
    cx: 71.533,
    cy: 419.253,
    r: 8.533
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#51565F"
    },
    d: "M422.4,478.72h-128c-39.253,0-53.76-8.533-69.12-17.067c-11.947-6.827-24.747-13.653-50.347-17.067 c-2.56,0-4.267-2.56-3.413-5.12c0.853-2.56,2.56-4.267,5.12-3.413c27.307,4.267,40.96,11.947,53.76,17.92 c15.36,8.533,29.013,15.36,65.707,15.36h128c11.093,0,21.333-10.24,21.333-21.333s-10.24-21.333-21.333-21.333 c-2.56,0-4.267-1.707-4.267-4.267s1.707-4.267,4.267-4.267h25.6c16.213,0,29.867-13.653,29.867-29.867S465.92,358.4,449.707,358.4 c-2.56,0-4.267-1.707-4.267-4.267c0-2.56,1.707-4.267,4.267-4.267h17.067c16.213,0,29.867-13.653,29.867-29.867 c0-16.213-13.653-29.867-29.867-29.867c-2.56,0-4.267-1.707-4.267-4.267c0-2.56,1.707-4.267,3.413-4.267 c20.48-2.56,30.72-10.24,30.72-24.747c0-16.213-12.8-34.987-29.867-34.987H347.307c-13.653,0-38.4-7.68-38.4-38.4 c0-2.56,1.707-4.267,4.267-4.267s4.267,1.707,4.267,4.267c0,29.013,29.013,29.867,29.867,29.867h119.467 c22.187,0,38.4,23.04,38.4,43.52c0,13.653-6.827,23.893-20.48,29.013c11.947,6.827,20.48,19.627,20.48,34.133 c0,18.773-13.653,34.987-32.427,37.547c9.387,6.827,15.36,17.92,15.36,30.72c0,21.333-17.067,38.4-38.4,38.4h-5.12 c5.973,5.12,9.387,12.8,9.387,21.333C452.267,464.213,437.76,478.72,422.4,478.72z M140.8,478.72H4.267 c-2.56,0-4.267-1.707-4.267-4.267v-256c0-2.56,1.707-4.267,4.267-4.267H140.8c2.56,0,4.267,1.707,4.267,4.267v256 C145.067,477.013,143.36,478.72,140.8,478.72z M8.533,470.187h128V222.72h-128V470.187z M72.533,436.053 c-6.827,0-12.8-5.973-12.8-12.8c0-6.827,5.973-12.8,12.8-12.8c6.827,0,12.8,5.973,12.8,12.8 C85.333,430.08,79.36,436.053,72.533,436.053z M72.533,418.987c-2.56,0-4.267,1.707-4.267,4.267c0,2.56,1.707,4.267,4.267,4.267 c2.56,0,4.267-1.707,4.267-4.267C76.8,420.694,75.093,418.987,72.533,418.987z M174.933,239.787c-2.56,0-4.267-1.707-4.267-4.267 s1.707-4.267,4.267-4.267c14.507,0,39.253-15.36,64.853-41.813c33.28-33.28,33.28-74.24,33.28-141.653 c0-11.947,9.387-21.333,21.333-21.333c36.693,0,55.467,18.773,55.467,55.467v102.4c0,2.56-1.707,4.267-4.267,4.267 s-4.267-1.707-4.267-4.267V81.92c0-31.573-15.36-46.933-46.933-46.933c-7.68,0-12.8,5.12-12.8,12.8c0,68.267,0,112.64-34.987,148.48 C218.453,223.573,192,239.787,174.933,239.787z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpBlack);
export default __webpack_public_path__ + "static/media/thumbs-up-black.4b6d5d8f242655d7fa69d2f67b038acd.svg";
export { ForwardRef as ReactComponent };